export default {
	namespace: 'contact',
	beforeEnter() {

	},
	afterEnter() {
		console.log('View: contact')
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
